// External Provider Batch Request Status
export enum EXTERNAL_PROVIDER_BATCH_REQUEST_STATUS {
  TO_REVIEW = "to_review",
  APPROVED = "approved",
  REJECTED = "rejected",
}

// External Provider Batch Participation Status
export enum EXTERNAL_PROVIDER_BATCH_PARTICIPATION_STATUS {
  CONFIRMED = "confirmed",
  FINISHED = "finished",
}

// External Provider Batch Participation Payment Status
export enum EXTERNAL_PROVIDER_BATCH_PARTICIPATION_PAYMENT_STATUS {
  PENDING_APPROVAL = "pending_approval",
  REFUSED = "refused",
  APPROVED = "approved",
  SENT_TO_PAYMENT_PROVIDER = "sent_to_payment_provider",
  PAYMENT_PROVIDER_FAILED = "payment_provider_failed",
}

// External Provider Batch Participation Payment Failure Reason
export enum EXTERNAL_PROVIDER_BATCH_PARTICIPATION_PAYMENT_FAILURE_REASON {
  SUPPLIER_CREATION_FAILED = "supplier_creation_failed",
  INVOICE_CREATION_FAILED = "invoice_creation_failed",
}

// Merged Status for Students (simplified view)
export enum EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS {
  REQUEST_PENDING_PROVIDER_VERIFICATION = "request_pending_provider_verification",
  REQUEST_TO_VALIDATE = "request_to_validate",
  REQUEST_REFUSED = "request_refused",
  SCHEDULED = "scheduled",
  RUNNING = "running",
  WAITING_FOR_INVOICE = "waiting_for_invoice",
  COMPLETED = "completed",
}

export const ExternalProviderBatchStudentMergedStatusLabelMap: Record<EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS, string> = {
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.REQUEST_PENDING_PROVIDER_VERIFICATION]: "En attente du presta.",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.REQUEST_TO_VALIDATE]: "En attente validation admin",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.REQUEST_REFUSED]: "Refusé",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.SCHEDULED]: "Planifié",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.RUNNING]: "En cours",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.WAITING_FOR_INVOICE]: "En attente facture presta.",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.COMPLETED]: "Terminé",
};

export const ExternalProviderBatchStudentMergedStatusBadgeVariants: Record<
  EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS,
  "default" | "destructive" | "success" | "warning"
> = {
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.REQUEST_PENDING_PROVIDER_VERIFICATION]: "warning",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.REQUEST_TO_VALIDATE]: "warning",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.REQUEST_REFUSED]: "destructive",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.SCHEDULED]: "default",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.RUNNING]: "default",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.WAITING_FOR_INVOICE]: "warning",
  [EXTERNAL_PROVIDER_BATCH_STUDENT_MERGED_STATUS.COMPLETED]: "success",
};

// Merged Status for Admin (detailed view with payment tracking)
export enum EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS {
  REQUEST_PENDING_PROVIDER_VERIFICATION = "request_pending_provider_verification",
  REQUEST_TO_VALIDATE = "request_to_validate",
  REQUEST_APPROVED = "request_approved",
  REQUEST_REFUSED = "request_refused",
  SCHEDULED = "scheduled",
  RUNNING = "running",
  WAITING_FOR_INVOICE = "waiting_for_invoice",
  INVOICE_TO_VALIDATE = "invoice_to_validate",
  INVOICE_REFUSED = "invoice_refused",
  TO_PROCESS_ON_PL = "to_process_on_pl",
  PL_ERROR = "pl_error",
  PAYMENT_PROCESSING = "payment_processing",
  PAID = "paid",
}

export const ExternalProviderBatchAdminMergedStatusLabelMap: Record<EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS, string> = {
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.REQUEST_PENDING_PROVIDER_VERIFICATION]: "Vérif. prestataire",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.REQUEST_TO_VALIDATE]: "Dem. à valider",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.REQUEST_APPROVED]: "Dem. approuvée",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.REQUEST_REFUSED]: "Dem. refusée",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.SCHEDULED]: "Planifié",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.RUNNING]: "En cours",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.WAITING_FOR_INVOICE]: "En attente facture",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.INVOICE_TO_VALIDATE]: "Facture à valider",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.INVOICE_REFUSED]: "Facture refusée",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.TO_PROCESS_ON_PL]: "À traiter sur PL",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.PL_ERROR]: "Erreur PL",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.PAYMENT_PROCESSING]: "Vir. en cours sur PL",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.PAID]: "Payé",
};

export const ExternalProviderBatchAdminMergedStatusBadgeVariants: Record<
  EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS,
  "default" | "destructive" | "success" | "warning" | "info"
> = {
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.REQUEST_PENDING_PROVIDER_VERIFICATION]: "default",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.REQUEST_TO_VALIDATE]: "warning",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.REQUEST_APPROVED]: "success",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.REQUEST_REFUSED]: "destructive",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.SCHEDULED]: "default",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.RUNNING]: "info",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.WAITING_FOR_INVOICE]: "warning",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.INVOICE_TO_VALIDATE]: "warning",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.INVOICE_REFUSED]: "destructive",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.TO_PROCESS_ON_PL]: "info",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.PL_ERROR]: "destructive",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.PAYMENT_PROCESSING]: "success",
  [EXTERNAL_PROVIDER_BATCH_ADMIN_MERGED_STATUS.PAID]: "success",
};

// Merged Status for Provider Portal (full lifecycle view)
export enum EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS {
  REQUEST_PENDING_PROVIDER_VERIFICATION = "request_pending_provider_verification",
  REQUEST_TO_VALIDATE = "request_to_validate",
  REQUEST_APPROVED = "request_approved",
  REQUEST_REFUSED = "request_refused",
  SCHEDULED = "scheduled",
  RUNNING = "running",
  WAITING_FOR_INVOICE = "waiting_for_invoice",
  INVOICE_TO_VALIDATE_BY_ADMIN = "invoice_to_validate_by_admin",
  INVOICE_REFUSED = "invoice_refused",
  INVOICE_APPROVED = "invoice_approved",
  PAID = "paid",
}

export const ExternalProviderBatchProviderMergedStatusLabelMap: Record<EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS, string> = {
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_PENDING_PROVIDER_VERIFICATION]: "En attente de vérification",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_TO_VALIDATE]: "En attente de validation admin",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_APPROVED]: "Demande approuvée",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_REFUSED]: "Demande refusée",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.SCHEDULED]: "Planifié",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.RUNNING]: "En cours",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.WAITING_FOR_INVOICE]: "En attente facture",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_TO_VALIDATE_BY_ADMIN]: "Facture en validation",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_REFUSED]: "Facture refusée",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_APPROVED]: "Facture approuvée",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.PAID]: "Payé",
};

export const ExternalProviderBatchProviderMergedStatusBadgeVariants: Record<
  EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS,
  "default" | "destructive" | "success" | "secondary" | "info"
> = {
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_PENDING_PROVIDER_VERIFICATION]: "secondary",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_TO_VALIDATE]: "info",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_APPROVED]: "success",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.REQUEST_REFUSED]: "destructive",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.SCHEDULED]: "info",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.RUNNING]: "info",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.WAITING_FOR_INVOICE]: "secondary",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_TO_VALIDATE_BY_ADMIN]: "info",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_REFUSED]: "destructive",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.INVOICE_APPROVED]: "success",
  [EXTERNAL_PROVIDER_BATCH_PROVIDER_MERGED_STATUS.PAID]: "success",
};
